import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.353 13.959a5.003 5.003 0 0 1-4.313-4.322L34 10.659V11a4 4 0 0 0 4 4h.337l1.016-1.041Zm-2.797 2.866a6.01 6.01 0 0 1-4.379-4.373l-8.052 7.92a.993.993 0 0 0-.125.149V21a4 4 0 0 0 4 4h.5c.024 0 .049 0 .073.003a.994.994 0 0 0 .05-.049l7.933-8.129ZM25.09 26.25a6.028 6.028 0 0 1-2.309-2.285L21.6 27.413l3.49-1.163Zm11.291-20.7a5 5 0 1 1 7.02 7.116 1.01 1.01 0 0 1-.076.085l-13.27 13.6a3 3 0 0 1-1.199.75l-6.623 2.208a2 2 0 0 1-2.524-2.546l2.279-6.652c.15-.44.402-.84.734-1.167L36.198 5.693a.982.982 0 0 1 .182-.142ZM43 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-3 11a1 1 0 1 1 2 0v5.966c0 3.469-.13 6.919-.388 10.35a9 9 0 0 1-8.298 8.297A137.13 137.13 0 0 1 23 45c-3.46 0-6.9-.13-10.32-.387a9 9 0 0 1-8.298-8.298 138.206 138.206 0 0 1 .007-20.63 9 9 0 0 1 8.298-8.298C16.105 7.129 19.543 7 23 7h6a1 1 0 1 1 0 2h-6c-3.407 0-6.794.127-10.163.381a7 7 0 0 0-6.454 6.454 136.205 136.205 0 0 0-.006 20.33 7 7 0 0 0 6.453 6.453C16.2 42.873 19.59 43 23 43c3.407 0 6.795-.127 10.164-.381a7 7 0 0 0 6.454-6.454c.255-3.38.382-6.78.382-10.2V20Z",
    fill: "currentColor"
  }));
};

var SvgNotes = styled(SvgComponent).withConfig({
  displayName: "Notes__SvgNotes",
  componentId: "sc-zowvih-0"
})(["", " ", ""], size, color);
export default SvgNotes;